import { Injectable, inject } from '@angular/core';
import { ToastrService } from 'ngx-toastr';

@Injectable({
  providedIn: 'root'
})
export class ToastrServices {
  private toastrService = inject(ToastrService);

  constructor() { }

  showSuccess(message: string, title?: string): void {
    this.toastrService.success(message, title);
  }

  showError(message: string, title?: string): void {
    this.toastrService.error(message, title);
  }

  showWarning(message: string, title?: string): void {
    this.toastrService.warning(message, title);
  }

  showInfo(message: string, title?: string): void {
    this.toastrService.info(message, title);
  }

  showCustom(message: string, title?: string, options?: any): void {
    this.toastrService.show(message, title, options);
  }
}
